import { ADD_ASSIGNED_USER_TO_EDITING_TASK, CHANGE_TASK_DONE_STATUS, CHANGE_USER_SETTINGS_MODAL_OPEN, CLOSE_ARCHIVE_TASK_MODAL, CLOSE_PIPELINE_MODAL, CLOSE_STAGE_MODAL, CLOSE_TASK_MODAL, CLOSE_USER_MODAL, OPEN_ARCHIVE_TASK_MODAL, OPEN_EDIT_PIPELINE_MODAL, OPEN_EDIT_TASK_MODAL, OPEN_EDIT_USER_MODAL, OPEN_NEW_PIPELINE_MODAL, OPEN_NEW_STAGE_MODAL, OPEN_NEW_USER_MODAL, OPEN_STAGE_EDIT_MODAL, REMOVE_ASSIGNED_USER_FROM_EDITING_TASK, } from "../constants";
import { initialState } from "../providers/ModalContextProvider";
const closeModal = () => {
    return Object.assign({}, initialState);
};
const reducer = (state, action) => {
    var _a, _b, _c, _d;
    switch (action.type) {
        case OPEN_EDIT_TASK_MODAL: {
            const { taskToEdit } = action.payload;
            return Object.assign(Object.assign({}, state), { taskModalOpen: true, taskToEdit, targetStageId: taskToEdit.stage_id });
        }
        case CLOSE_TASK_MODAL: {
            return closeModal();
        }
        case ADD_ASSIGNED_USER_TO_EDITING_TASK: {
            const user = action.payload;
            return Object.assign(Object.assign({}, state), { taskToEdit: Object.assign(Object.assign({}, state.taskToEdit), { assigned_users: [user, ...((_b = (_a = state.taskToEdit) === null || _a === void 0 ? void 0 : _a.assigned_users) !== null && _b !== void 0 ? _b : [])] }) });
        }
        case REMOVE_ASSIGNED_USER_FROM_EDITING_TASK: {
            const user = action.payload;
            return Object.assign(Object.assign({}, state), { taskToEdit: Object.assign(Object.assign({}, state.taskToEdit), { assigned_users: ((_d = (_c = state.taskToEdit) === null || _c === void 0 ? void 0 : _c.assigned_users) !== null && _d !== void 0 ? _d : []).filter((assignedUser) => assignedUser.id !== user.id) }) });
        }
        case OPEN_NEW_STAGE_MODAL: {
            const { targetPipelineId } = action.payload;
            return Object.assign(Object.assign({}, state), { stageModalOpen: true, targetPipelineId });
        }
        case OPEN_STAGE_EDIT_MODAL: {
            const { stageToEdit } = action.payload;
            return Object.assign(Object.assign({}, state), { stageModalOpen: true, stageToEdit });
        }
        case CLOSE_STAGE_MODAL: {
            return closeModal();
        }
        case OPEN_NEW_PIPELINE_MODAL: {
            return Object.assign(Object.assign({}, state), { newPipelineModalOpen: true });
        }
        case OPEN_EDIT_PIPELINE_MODAL: {
            const { pipelineToEdit } = action.payload;
            return Object.assign(Object.assign({}, state), { pipelineModalOpen: true, pipelineToEdit });
        }
        case CLOSE_PIPELINE_MODAL: {
            return closeModal();
        }
        case OPEN_ARCHIVE_TASK_MODAL: {
            const archiveTask = action.payload;
            return Object.assign(Object.assign({}, state), { archiveTaskModalOpen: true, archiveModalTask: archiveTask });
        }
        case CLOSE_ARCHIVE_TASK_MODAL: {
            return closeModal();
        }
        case OPEN_NEW_USER_MODAL: {
            return Object.assign(Object.assign({}, state), { userModalOpen: true });
        }
        case OPEN_EDIT_USER_MODAL: {
            const userToEdit = action.payload;
            return Object.assign(Object.assign({}, state), { userModalOpen: true, userToEdit });
        }
        case CLOSE_USER_MODAL: {
            return closeModal();
        }
        case CHANGE_USER_SETTINGS_MODAL_OPEN: {
            const open = action.payload;
            if (open) {
                return Object.assign(Object.assign({}, state), { userSettingsModalOpen: true });
            }
            return closeModal();
        }
        case CHANGE_TASK_DONE_STATUS: {
            const { done } = action.payload;
            return Object.assign(Object.assign({}, state), { taskToEdit: Object.assign(Object.assign({}, state.taskToEdit), { is_done: done }) });
        }
        default:
            return state;
    }
};
export { reducer };
